import { render, staticRenderFns } from "./episode-card.vue?vue&type=template&id=495c4ed2&scoped=true&"
import script from "./episode-card.vue?vue&type=script&lang=js&"
export * from "./episode-card.vue?vue&type=script&lang=js&"
import style0 from "./episode-card.vue?vue&type=style&index=0&id=495c4ed2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495c4ed2",
  null
  
)

export default component.exports